// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const RadarText: MarkdocTagRegistration = {
  tag: 'radar-text',
  component: 'RadarText',
  attributes: {
    type: {
      type: String,
      required: true,
      matches: [
        'attribute',
        'metadata',
        'numeric',
        'string',
        'red',
        'amber',
        'green',
      ],
      description: 'Type of the given radar text',
    },
  },
};
